import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import {
  Candidacy,
  HttpResponse,
  ParseScreeningQuestionsAndAnswersRequest,
} from "@/types";

export function useParseScreeningQuestionsAndAnswers() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      parseScreeningQuestionsAndAnswersRequest,
    }: {
      candidacyId: string;
      parseScreeningQuestionsAndAnswersRequest: ParseScreeningQuestionsAndAnswersRequest;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/screening-answers`;
      const res = await guacHttpClient.post<
        Candidacy,
        HttpResponse<Candidacy>,
        ParseScreeningQuestionsAndAnswersRequest
      >(path, parseScreeningQuestionsAndAnswersRequest);

      return res.data;
    },
  });

  return mutation;
}
